import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './swap.svg'


_pushScopeId("data-v-717fb94a")
const _hoisted_1 = ["square", "noBorder"]
const _hoisted_2 = { class: "grid-table min-w-[480px]" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"header\" data-v-717fb94a><div class=\"ml-[24px] h-4\" data-v-717fb94a>Action</div><div class=\"h-4\" data-v-717fb94a>Value</div><div class=\"h-4\" data-v-717fb94a>Tokens</div><div class=\"h-4\" data-v-717fb94a>Time</div></div><div class=\"border\" data-v-717fb94a></div>", 2)
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "flex w-full items-center" }
const _hoisted_7 = { class: "flex items-center justify-start" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "value-text text-right" }
const _hoisted_10 = { class: "flex items-center justify-start" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = { class: "token-item" }
const _hoisted_14 = { class: "font-numeric mx-[7px]" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "mx-[12px]"
}, null, -1)
const _hoisted_16 = { class: "token-item" }
const _hoisted_17 = { class: "font-numeric mx-[7px]" }
const _hoisted_18 = { class: "flex items-center justify-start" }
const _hoisted_19 = ["href"]
_popScopeId()

import { formatDistanceToNow } from 'date-fns';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { ColumnDefinition } from '@/components/_global/BalTable/BalTable.vue';
import useBreakpoints from '@/composables/useBreakpoints';
import useNumbers, { FNumFormats } from '@/composables/useNumbers';
import useTokens from '@/composables/useTokens';
import { shortenLabel } from '@/lib/utils';
import { bnum } from '@/lib/utils';
import { PoolSwap } from '@/services/pool/types';
import useWeb3 from '@/services/web3/useWeb3';

/**
 * TYPES
 */
type SwapRow = {
  tokenIn: string;
  tokenOut: string;
  tokenAmountIn: string;
  tokenAmountOut: string;
  timestamp: number;
  formattedDate: string;
  value: number;
  formattedValue: string;
  tx: string;
};

type Props = {
  tokens: string[];
  poolSwaps: PoolSwap[];
  isLoading?: boolean;
  isLoadingMore?: boolean;
  // eslint-disable-next-line vue/require-default-prop -- TODO: Define default prop
  loadMore?: () => void;
  isPaginated?: boolean;
  noResultsLabel?: string;
};

/**
 * PROPS & EMITS
 */

export default _defineComponent({
  props: {
    tokens: { type: Array, required: true },
    poolSwaps: { type: Array, required: true },
    isLoading: { type: Boolean, required: false, default: false },
    isLoadingMore: { type: Boolean, required: false, default: false },
    loadMore: { type: Function, required: false },
    isPaginated: { type: Boolean, required: false, default: false },
    noResultsLabel: { type: String, required: false, default: '' }
  } as unknown as undefined,
  emits: ['loadMore'],
  setup(__props: {
  tokens: string[];
  poolSwaps: PoolSwap[];
  isLoading?: boolean;
  isLoadingMore?: boolean;
  // eslint-disable-next-line vue/require-default-prop -- TODO: Define default prop
  loadMore?: () => void;
  isPaginated?: boolean;
  noResultsLabel?: string;
}, { emit }) {

const props = __props




/**
 * COMPOSABLES
 */
const { fNum2 } = useNumbers();
const { t } = useI18n();
const { priceFor } = useTokens();
const { upToLargeBreakpoint } = useBreakpoints();
const { explorerLinks } = useWeb3();
const { isMobile, isDesktop } = useBreakpoints();

/**
 * COMPUTED
 */
const columns = computed<ColumnDefinition<SwapRow>[]>(() => [
  {
    name: t('trader'),
    id: 'action',
    accessor: 'tx',
    Cell: 'actionCell',
    width: 190,
    sortable: false,
  },
  {
    name: t('value'),
    id: 'value',
    accessor: 'value',
    Cell: 'valueCell',
    align: 'right',
    className: 'align-center w-40',
    sortKey: pool => pool.value,
    width: 125,
  },
  {
    name: t('tradeDetails'),
    id: 'details',
    accessor: '',
    Cell: 'detailsCell',
    width: 310,
    sortable: false,
  },

  {
    name: t('time'),
    id: 'timeAgo',
    accessor: 'timestamp',
    Cell: 'timeCell',
    align: 'right',
    sortKey: pool => pool.timestamp,
    width: 200,
  },
]);

const swapRows = computed<SwapRow[]>(() =>
  props.isLoading
    ? []
    : props.poolSwaps.map(
        ({
          tokenIn,
          tokenOut,
          tokenAmountIn,
          tokenAmountOut,
          timestamp,
          tx,
          userAddress,
          ensName,
          ensAvatar,
        }) => {
          const value = bnum(priceFor(tokenOut))
            .times(tokenAmountOut)
            .toNumber();

          return {
            value,
            formattedValue:
              value > 0
                ? fNum2(value, { style: 'currency', abbreviate: true })
                : '-',
            tokenIn,
            tokenOut,
            tokenAmountIn,
            tokenAmountOut,
            timestamp,
            userAddress: userAddress.id,
            ensName,
            ensAvatar,
            formattedDate: t('timeAgo', [formatDistanceToNow(timestamp)]),
            tx,
          };
        }
      )
);

return (_ctx: any,_cache: any) => {
  const _component_BalAsset = _resolveComponent("BalAsset")!

  return (_openBlock(), _createElementBlock("div", {
    class: "table-container overflow-x-auto p-[24px]",
    square: _unref(upToLargeBreakpoint),
    noBorder: _unref(upToLargeBreakpoint),
    noPad: ""
  }, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(swapRows), (action, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "flex table-row w-full items-center"
        }, [
          _createElementVNode("a", {
            href: _unref(explorerLinks).txLink(action.tx),
            class: "pool-row my-[18px] flex w-full items-center",
            target: "_blank"
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_BalAsset, {
                class: "mr-2",
                address: action.userAddress,
                iconURI: action.ensAvatar,
                size: 24
              }, null, 8, ["address", "iconURI"]),
              _createTextVNode(" " + _toDisplayString(action.ensName || _unref(shortenLabel)(action.userAddress)), 1)
            ])
          ], 8, _hoisted_5),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", {
              href: _unref(explorerLinks).txLink(action.tx),
              target: "_blank"
            }, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(action.formattedValue), 1)
            ], 8, _hoisted_8)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("a", {
              href: _unref(explorerLinks).txLink(action.tx),
              target: "_blank",
              class: _normalizeClass(["flex", { 'justify-left': _unref(isDesktop), 'justify-end': _unref(isMobile) }])
            }, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_BalAsset, {
                    address: action.tokenIn,
                    class: "mr-[8px] pt-[3px]",
                    size: 16
                  }, null, 8, ["address"]),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(fNum2)(action.tokenAmountIn, _unref(FNumFormats).token)), 1)
                ]),
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_BalAsset, {
                    address: action.tokenOut,
                    class: "mr-[8px] pt-[3px]",
                    size: 16
                  }, null, 8, ["address"]),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(fNum2)(action.tokenAmountOut, _unref(FNumFormats).token)), 1)
                ])
              ])
            ], 10, _hoisted_11)
          ]),
          _createElementVNode("div", _hoisted_18, [
            (_unref(isDesktop))
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: _unref(explorerLinks).txLink(action.tx),
                  target: "_blank",
                  class: "value-text text-right"
                }, _toDisplayString(action.formattedDate), 9, _hoisted_19))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128))
    ])
  ], 8, _hoisted_1))
}
}

})